import Vue from "vue";

export const realEstateService = {
  list,
  getById,
  create,
  update
};

function list(params) {
  return Vue.axios.get("v2/admin/state_agencies", { params });
}

function getById(id) {
  return Vue.axios.get(`v2/admin/state_agencies/${id}`);
}

function create(payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("support_phone", payload.support_phone);
  formData.set("email_documentation", payload.mail);
  formData.set("all_properties_is_visible", payload.all_properties_is_visible);
  payload.manager_ids.forEach(manager_id => {
    formData.append("manager_ids[]", manager_id);
  });

  return Vue.axios.post(`v2/admin/state_agencies`, formData);
}

function update(payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("support_phone", payload.support_phone);
  formData.set("email_documentation", payload.mail);
  formData.set("all_properties_is_visible", payload.all_properties_is_visible);
  payload.manager_ids.forEach(manager_id => {
    formData.append("manager_ids[]", manager_id);
  });

  if (payload.building_ids.length) {
    payload.building_ids.forEach(building_id => {
      formData.append("building_ids[]", building_id);
    });
  } else {
    formData.set("building_ids[]", []);
  }
  return Vue.axios.patch(`v2/admin/state_agencies/${payload.id}`, formData);
}
